import { render, staticRenderFns } from "./FormResetPassword.vue?vue&type=template&id=2cae48b6&"
import script from "./FormResetPassword.vue?vue&type=script&lang=js&"
export * from "./FormResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports